import React from "react";
import "./style.scss";

export type ConsentHeaderProps = {
  headerTitle: string;
  batchDangerWord?: string;
  batchAnyWord?: string;
};

export const ConsentHeader = (props: ConsentHeaderProps) => {
  const { headerTitle, batchDangerWord, batchAnyWord } = props;
  return (
    <div className="consentHeader">
      <span className="consentHeader_title">{headerTitle}</span>
      {/* TODO:バッチのスタイル改修 */}
      {batchDangerWord && (
        <div className="consentHeader_batchDanger ">{batchDangerWord}</div>
      )}
      {batchAnyWord && (
        <div className="consentHeader_batchAny ">{batchAnyWord}</div>
      )}
    </div>
  );
};
